import { inquiryInboundInfo } from '@root/state/reducers/Settlement/settlementReducer';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Col, DatePicker, Divider, Row } from 'antd';
import moment from 'moment';
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY.MM.DD';

function InqueryHistory({
  inquiryHistory,
  getDate,
  dateFrom,
  dateTo,
  confirm,
  dates,
  idCustomer
}: {
  inquiryHistory?: inquiryInboundInfo;
  getDate: (startDate?: string, endDate?: string) => void;
  dateFrom?: string;
  dateTo?: string;
  confirm?: boolean;
  idCustomer?: number | string;
  dates?: { startDate: string | number; endDate: string | number };
}) {
  const handleChangeDate = (range: any) => {
    if (range) {
      const valueOfInput1 = formatDateTime(range[0]);
      const valueOfInput2 = formatDateTime(range[1]);
      getDate(valueOfInput1, valueOfInput2);
    } else {
      getDate();
    }
  };
  return (
    <div>
      <Row style={{ margin: '25px 0' }}>
        <Col span={8}>
          <h2 style={{ marginBottom: '20px' }}>Inquiry History</h2>
        </Col>
        <Col span={16} align="right" className="centerNumber">
          {dates && (
            <RangePicker
              className="datePicker"
              disabled
              defaultValue={[moment(dates.startDate), moment(dates.endDate)]}
              format={dateFormat}
            />
          )}
          {!confirm && !dates && (
            <RangePicker
              className="datePicker"
              format={dateFormat}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              onChange={handleChangeDate}
            />
          )}
          {confirm && (
            <RangePicker
              className="datePicker"
              disabled
              format={dateFormat}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              defaultValue={[moment(dateFrom), moment(dateTo)]}
              onChange={handleChangeDate}
            />
          )}
        </Col>
        <Col span={6} className="centerText">
          <p>Number of product types in storage </p>
        </Col>
        <Col span={16}>
          <Divider dashed style={{ borderWidth: '2px 0 0' }} />
        </Col>
        <Col span={3} align="right" className="centerNumber">
          <p>{idCustomer ? inquiryHistory?.numberProductTypes : 0} </p>
        </Col>
        <Col span={6} className="centerText">
          <p>Total Order Counts </p>
        </Col>
        <Col span={16}>
          <Divider dashed style={{ borderWidth: '2px 0 0' }} />
        </Col>
        <Col span={3} align="right" className="centerNumber">
          <p>{idCustomer ? inquiryHistory?.orderCounts : 0} </p>
        </Col>
      </Row>
      <Row style={{ marginBottom: '25px' }}>
        <Col span={24}>
          <h2>Inbound History</h2>
        </Col>
        <Col span={6} className="centerText">
          <p>Delivered </p>
        </Col>
        <Col span={16}>
          <Divider dashed style={{ borderWidth: '2px 0 0' }} />
        </Col>
        <Col span={3} align="right" className="centerNumber">
          <p>{idCustomer ? inquiryHistory?.numberDelivered : 0}</p>
        </Col>
        <Col span={6} className="centerText">
          <p>Returned</p>
        </Col>
        <Col span={16}>
          <Divider dashed style={{ borderWidth: '2px 0 0' }} />
        </Col>
        <Col span={3} align="right" className="centerNumber">
          <p>{idCustomer ? inquiryHistory?.numberReturn : 0}</p>
        </Col>
        <Col span={6} className="centerText">
          <p>Disposal</p>
        </Col>
        <Col span={16}>
          <Divider dashed style={{ borderWidth: '2px 0 0' }} />
        </Col>
        <Col span={3} align="right" className="centerNumber">
          <p>{idCustomer ? inquiryHistory?.numberDisposal : 0}</p>
        </Col>
      </Row>
    </div>
  );
}

export default InqueryHistory;
